module.exports = __webpack_public_path__ + "static/media/wgl-logo.9905cb24.png";